
import React from 'react';
import { Image } from '@themesberg/react-bootstrap';

import ReactLogo from "../assets/img/technologies/react-logo-transparent.svg";

/**
 * Loading overlay. Pass show={true} while loading.
 * When show={false}, nothing is rendered (avoids a fixed full-viewport node that can block clicks).
 */
export default function Preloader({ show }) {
  if (!show) {
    return null;
  }

  return (
    <div className="preloader bg-soft flex-column justify-content-center align-items-center">
      <Image className="loader-element animate__animated animate__jackInTheBox" src={ReactLogo} height={40} />
    </div>
  );
}
